import React, { useState } from "react";
import { Modal, Divider, Spin } from "antd";
import styles from "./parent-otp-modal.module.css";
import CustomTextfield from "../../../../common/input/custom-textfield/custom-textfield";
import { Controller, useForm } from "react-hook-form";
import CustomButton from "../../../../common/custom-button/custom-button";
import { toast } from "react-toastify";
import { parentSendOtp, parentVerifyOtp } from "../../../../services/parent_form";

const ParentOtpModal = ({
  visible,
  onClose,
  formValues,
  otpVerificationId,
  setOtpVerificationId,
  submitAfterVerification,
}) => {
  const { control, handleSubmit, reset } = useForm();
  const [loading, setLoading] = useState(false);

  const resentOtp = async () => {
    try {
      setLoading(true);
      const payload = {
        phone_number: formValues?.phone_number,
        email: formValues?.email,
        institution_id: formValues?.institutionId,
        resend: true
      };
      const response = await parentSendOtp(payload);
      if (response?.data?.status) {
        setOtpVerificationId(response?.data?.data?.id);
      }  else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (formData) => {
    try {
      setLoading(true);
      const payload = {
        id: otpVerificationId,
        otp_code: formData?.otp
      };

      const response = await parentVerifyOtp(payload);
      if (response?.data?.status) {
        handleOnClose();
        submitAfterVerification();
      }  else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleOnClose = () => {
    reset();
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={handleOnClose}
      centered
      footer={null}
      width={500}
      title={
        <>
          <div className={styles.modalTitle}>OTP Verification</div>
          <Divider className={styles.modalTitleDivider} />
        </>
      }
    >
      <Spin spinning={loading}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="otp"
            control={control}
            rules={{ required: true }}
            render={({
              field: { onChange, value },
              fieldState: { error },
            }) => (
            <CustomTextfield
              id="otp"
              label="Check your email or phone number"
              labelColor="#171717"
              placeholder="Enter OTP Received"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
            )}
          />
          <div className={styles.verifyOtp}>
            <p className={styles.resendText}>
              <span>OTP not received? </span>
              <span 
                className={styles.resendButton}
                onClick={resentOtp}
              >
                Resend OTP
              </span>
            </p>
            <CustomButton
              title="Verify OTP"
              type="primary"
              htmlType="submit"
              variant="outlined"
            />
          </div>
        </form>
      </Spin>
    </Modal>
  );
};

export default ParentOtpModal;
